// The Vue build version to load with the `import` command
import 'promise-polyfill/src/polyfill' // promise兼容性库
import 'whatwg-fetch' // fetch兼容性库
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import mixin from './mixin'

Vue.config.productionTip = false

// 混入一些在全局使用的功能
mixin()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () { // 自动登陆，检查sessionStorage中是否有token
    // this.$router.push('/Nopay')
    // this.$router.push('/Test')
    let token = sessionStorage.getItem('token')
    if (token) {
      this.$router.push('/Main')
    } else {
      localStorage.clear()
      this.$router.push('/Login')
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js